(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pbs-card-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pbs-card-variants')) {
  customElements.define('pbs-card-variants', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
    }
    disconnectedCallback() { this.observer.disconnect(); }
    fit() {
      const chips = [...this.querySelectorAll('a:not(.pbs-variants__more)')];
      const more = this.querySelector('.pbs-variants__more');
      if (!chips.length || !more || !this.clientWidth) return;
      const rowWidth = this.clientWidth;
      this.setAttribute('data-measuring', '');
      chips.forEach(chip => chip.hidden = false);
      more.hidden = false;
      const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
      const widths = chips.map(chip => chip.getBoundingClientRect().width);
      const allWidth = widths.reduce((a,b) => a+b,0) + gap*(chips.length-1);
      const needsMore = Number(this.dataset.total) > chips.length || allWidth > rowWidth;
      const available = rowWidth - (needsMore ? more.getBoundingClientRect().width + gap : 0);
      let used = 0, count = 0;
      widths.forEach((width,index) => {
        const next = used + (index ? gap : 0) + width;
        if (index === count && next <= available) { used = next; count++; }
      });
      count = Math.max(1,count);
      chips.forEach((chip,index) => chip.hidden = index >= count);
      more.hidden = !needsMore;
      this.style.setProperty('--pbs-chip-max', Math.max(0,available) + 'px');
      this.removeAttribute('data-measuring');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pbs-collection-vignettes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pbs-collection-rail')) {
  customElements.define('pbs-collection-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pbs-rail__track');
      this.controls = this.querySelector('.pbs-rail__controls');
      this.buttons = [...this.querySelectorAll('button[data-direction]')];
      this.progress = this.querySelector('.pbs-rail__progress > span');
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.max(0, this.track.scrollLeft);
        this.controls.hidden = maximum < 2;
        this.buttons[0].disabled = position < 2;
        this.buttons[1].disabled = position >= maximum - 2;
        const fraction = this.track.clientWidth / this.track.scrollWidth;
        this.progress.style.width = Math.min(100, fraction * 100) + '%';
        this.progress.style.marginLeft = maximum > 0 ? (position / maximum * (1 - fraction) * 100) + '%' : '0';
      };
      this.onClick = event => {
        const button = event.target.closest('button[data-direction]');
        if (!button || !this.contains(button)) return;
        const first = this.track.querySelector('li');
        const distance = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({left: distance * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };

      this.onPointerDown = event => {
        if (!matchMedia('(max-width: 749px)').matches || !event.isPrimary || event.button > 0) return;
        this.suppressClick = false;
        this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:this.track.scrollLeft, active:false};
      };
      this.onPointerMove = event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { this.drag = null; return; }
          drag.active = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = drag.left - dx;
      };
      this.onPointerEnd = event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        this.drag = null;
        if (!drag.active) return;
        this.suppressClick = true;
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        const step = this.track.querySelector('li').getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollTo({left:Math.round(this.track.scrollLeft / step) * step, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        this.update();
      };
      this.onTrackClick = event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      };
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove, {passive:false});
      this.track.addEventListener('pointerup', this.onPointerEnd);
      this.track.addEventListener('pointercancel', this.onPointerEnd);
      this.track.addEventListener('click', this.onTrackClick, true);

      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('pointerup', this.onPointerEnd);
      this.track?.removeEventListener('pointercancel', this.onPointerEnd);
      this.track?.removeEventListener('click', this.onTrackClick, true);
      this.track?.removeEventListener('scroll', this.update);
      this.removeEventListener('click', this.onClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-associated"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pbs-color-row')) {
  customElements.define('pbs-color-row', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      this.fit();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    fit() {
      const chips = [...this.querySelectorAll('a:not(.pbs-colors-more)')];
      const more = this.querySelector('.pbs-colors-more');
      const width = this.clientWidth;
      if (!width || !more || !chips.length) return;
      const gap = 4, size = 40, moreSize = 24;
      const needsMore = more.dataset.overflow === 'true' || chips.length * (size + gap) - gap > width;
      const count = Math.max(1, Math.min(5, Math.floor((width + gap - (needsMore ? moreSize + gap : 0)) / (size + gap))));
      chips.forEach((chip, i) => { chip.hidden = i >= count; });
      more.hidden = !needsMore;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
